<template>
    <div class="flex flex-col text-sm text-black"
    >
        <div class="flex h-8 items-center gap-2 px-2"  v-if="progressItem.step">
            <PtIcon v-if="haveFinished" class="h-6 w-6 shrink-0 fill-eureka-500"  icon="SolidTick" />
            <span v-else class="th-loading th-loading-spinner th-loading-sm"></span>
            <div v-html="progressItem.step">
            </div>
        </div>

        <ul class="list-disc bg-gray-10 p-3 pl-6 text-grey-450 " v-if="content" v-html="content">
        </ul>
    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz'
import { computed } from 'vue';
import type { GenerateLoadingProcess } from '@/types';
import '@patsnap-ui/icon/assets/solid/tick.svg';
import '@patsnap-ui/icon/assets/solid/SmallDot.svg';
import { splitText } from '@eureka/utils/text';

const props = defineProps<{
    progressItem: GenerateLoadingProcess;
}>();

const haveFinished = computed(() => props.progressItem.haveFinish)

const content = computed(() => {
    if (!props.progressItem.content) return
    return splitText(props.progressItem.content).map(p => `<li class="mb-2.5 last:mb-0 marker:text-grey-55">${p}</li>`).join('')
})

</script>
